import {gsap} from 'gsap';

( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( !window.hasMotion ) return;
      this.initIconAnimation();
    },

    initIconAnimation: function() {
      document.querySelectorAll( '.btn-primary' ).forEach( ( btn ) => {
        const icon = btn.querySelector( '.btn-primary__icon' );
        if ( !icon ) return;

        const bars = icon.querySelectorAll( 'line' );
        if ( bars.length !== 7 ) return;

        // Indexed bar0..bar6, matching DOM order (0°, 51°, 103°, 154°, 206°, 257°, 309°).
        // Bars 3 (lower-left), 4 (left), 5 (upper-left) sweep right to form the arrow.
        // Bars 0, 1, 2, 6 fade in place.
        const arrowTargets = [
          {fade: true},
          {fade: true},
          {fade: true},
          {fade: false, x1: 11, y1: 15, x2: 16, y2: 10}, // arrowhead lower
          {fade: false, x1: 2, y1: 10, x2: 16, y2: 10}, // shaft
          {fade: false, x1: 11, y1: 5, x2: 16, y2: 10}, // arrowhead upper
          {fade: true},
        ];

        const originals = Array.from( bars ).map( ( bar ) => ( {
          x1: parseFloat( bar.getAttribute( 'x1' ) ),
          y1: parseFloat( bar.getAttribute( 'y1' ) ),
          x2: parseFloat( bar.getAttribute( 'x2' ) ),
          y2: parseFloat( bar.getAttribute( 'y2' ) ),
          opacity: parseFloat( bar.getAttribute( 'opacity' ) || '1' ),
        } ) );

        // CCW sweep: upper-right clears first, upper-left (brightest) lands last
        const CCW = [6, 0, 1, 2, 3, 4, 5];
        const STAGGER = 0.045;
        const DUR = 0.32;

        let tl = null;

        btn.addEventListener( 'mouseenter', () => {
          if ( tl ) tl.kill();
          tl = gsap.timeline();

          CCW.forEach( ( idx, i ) => {
            const t = arrowTargets[idx];
            if ( t.fade ) {
              tl.to( bars[idx], {
                duration: DUR * 0.7,
                attr: {opacity: 0},
                ease: 'power2.in',
              }, i * STAGGER );
            } else {
              tl.to( bars[idx], {
                duration: DUR,
                attr: {x1: t.x1, y1: t.y1, x2: t.x2, y2: t.y2, opacity: 1},
                ease: 'power2.inOut',
              }, i * STAGGER );
            }
          } );
        } );

        btn.addEventListener( 'mouseleave', () => {
          if ( tl ) tl.kill();
          tl = gsap.timeline();

          [...CCW].reverse().forEach( ( idx, i ) => {
            const o = originals[idx];
            tl.to( bars[idx], {
              duration: DUR,
              attr: {x1: o.x1, y1: o.y1, x2: o.x2, y2: o.y2, opacity: o.opacity},
              ease: 'power2.inOut',
            }, i * STAGGER );
          } );
        } );
      } );
    },

    finalize: function() {},
  };

  app.registerComponent( 'primary-button', COMPONENT );
} )( app );
